import { IntegrationIconProps } from './types';

const Asana = ({ dimension }: IntegrationIconProps) => (
  <svg
    width={dimension || 32}
    height={dimension || 32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 2C8.27812 2 2 8.27812 2 16C2 23.7219 8.27812 30 16 30C23.7219 30 30 23.7219 30 16C30 8.27812 23.7219 2 16 2Z"
      fill="url(#paint0_radial_1334_1118)"
    />
    <path
      d="M20.5204 15.9411C18.5984 15.9411 17.0406 17.5212 17.0406 19.4704C17.0406 21.4198 18.5984 23 20.5204 23C22.4421 23 24 21.4198 24 19.4704C24 17.5212 22.4421 15.9411 20.5204 15.9411ZM11.4797 15.9414C9.55797 15.9414 8 17.5212 8 19.4706C8 21.4198 9.55797 23 11.4797 23C13.4016 23 14.9596 21.4198 14.9596 19.4706C14.9596 17.5212 13.4016 15.9414 11.4797 15.9414ZM19.4796 11.5293C19.4796 13.4785 17.9218 15.059 16.0001 15.059C14.0782 15.059 12.5203 13.4785 12.5203 11.5293C12.5203 9.58021 14.0782 8 16.0001 8C17.9218 8 19.4796 9.58021 19.4796 11.5293Z"
      fill="white"
    />
    <defs>
      <radialGradient
        id="paint0_radial_1334_1118"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(16 17.3026) scale(18.5537)"
      >
        <stop stopColor="#FFB900" />
        <stop offset="0.6" stopColor="#F95D8F" />
        <stop offset="0.9991" stopColor="#F95353" />
      </radialGradient>
    </defs>
  </svg>
);
export default Asana;
